import React from "react";
import FechaSection from "../sections/FechaSection";

const FechaPrint = () => {
  return (
    <div>
      <FechaSection />
    </div>
  );
};

export default FechaPrint;
